import { RootState } from 'src/redux/store';

export const selectIndexConfig = (state: RootState) => state.index.config;
export const selectAuth = (state: RootState) => state.common.auth;
